import { Action } from 'redux'
import { reportsApi } from '../api/reportsApi'
import { settingsApi } from '../api/settingsApi'
import { userApi } from '../api/userApi'
import { Report } from '../dtos/Report'
import { actionCreators as reportsActionCreators } from './Reports/actionCreators'
import { actionCreators as systemActionCreators } from './System/actionCreators'
import { actionCreators as settingsActionCreators } from './Settings/actionCreators'
import ReportsActions, { DeleteReportAction, FetchReportsAction } from './Reports/actions'
import UserActions, { LoginUserAction } from './User/actions'
import SettingsActions from './Settings/actions'
import PNotify from 'pnotify/dist/es/PNotify'

const apiMiddleware = ({ dispatch }) => next => (action: Action) => {
    let incomingAction = null
console.log(action.type)
    switch(action.type) {
        case ReportsActions.FETCH_REPORTS:
            incomingAction = action as FetchReportsAction
            dispatch(reportsActionCreators.setReports([] as Report[]))
            dispatch(systemActionCreators.setIsBusy(true, 'Pobieranie danych z serwera'))
            reportsApi.getReports(incomingAction.serviceContractOnly)
                .then(result => {
                    dispatch(reportsActionCreators.setReports(result))
                })
                .finally(() => {
                    dispatch(systemActionCreators.setIsBusy(false, ''))
                })
            break
        case ReportsActions.DELETE_REPORT:
            incomingAction = action as DeleteReportAction
            dispatch(systemActionCreators.setIsBusy(true, 'Usuwam raport'))
            reportsApi.deleteReport(incomingAction.reportId)
                .then(() => {
                    dispatch(reportsActionCreators.softDeleteReport(incomingAction.reportId))
                    dispatch(reportsActionCreators.selectReport(null))
                })
                .finally(() => {
                    dispatch(systemActionCreators.setIsBusy(false, ''))
                })
            break
        case UserActions.LOGIN:
            incomingAction = action as LoginUserAction
            dispatch(systemActionCreators.setIsBusy(true, 'Logowanie'))

            userApi.login(incomingAction.login, incomingAction.password)
                .then(result => {
                    console.log(result)
                    if (!result.data.isSuccess) {
                        PNotify.error({
                            title: 'Błąd logowania',
                            text: 'Niepoprawny login lub hasło'
                        })
                        return
                    }

                    localStorage.setItem('accessToken', result.data.token)
                    localStorage.setItem('refreshToken', result.data.refreshToken)
                    localStorage.setItem('user', JSON.stringify(result.data.user))
                    // eslint-disable-next-line no-restricted-globals
                    location.reload()

                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => {
                    dispatch(systemActionCreators.setIsBusy(false, ''))
                })
            break
        case SettingsActions.GET_SETTINGS:
            console.log('asd')
            dispatch(systemActionCreators.setIsBusy(true, 'Pobieranie ustawień'))

            settingsApi.getSettings()
                .then(result => {
                    dispatch(settingsActionCreators.setSettings(result.data))
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => {
                    dispatch(systemActionCreators.setIsBusy(false, ''))
                })
    }
    next(action)
}
export default apiMiddleware
